import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

export async function fetchUserById(
  id: string,
): Promise<PowerUpServiceResponseBody["getUserById"][200]> {
  return handleClientMethod(
    getClient().GET("/users/{id}", {
      params: { path: { id } },
    }),
  );
}

export const getUserByIdQuery = (id: string) => {
  return queryOptions({
    queryKey: ["users", "get-by-id", id],
    queryFn: () => fetchUserById(id),
  });
};
